<template>
    <md-dialog ref="synErrorDialog">
      <md-dialog-title>Resolução de erro</md-dialog-title>
        <md-dialog-content>
            <div><span> <b>Fonte do problema:</b> {{error}}</span></div>
            <div><b>Itens com problema</b></div>
            <md-list>
              <md-list-item v-for="(item,key) in photoErrors" :key="item['.key']">
                <div class="md-list-text-container">
                  <span>{{item.name}} - {{item.photo.name}}</span>
                  <camera-image-select ref="cameraImageSelect" :photoId="key" :description="item.photo.description" :imageId="item.photo.image" ></camera-image-select>
                </div>
              </md-list-item>
            </md-list>
            <div>
            <md-button class="md-accent md-raised" @click="startProcess">ENVIAR DADOS</md-button>
            </div>
        </md-dialog-content>
    </md-dialog>
</template>
<script>
import CameraImageSelect from '@/components/CameraImageSelect'
export default {
  name: 'SyncErrorDialog',
  components: {
    CameraImageSelect
  },
  props: {
    error: String,
    photoErrors: Array
  },
  methods: {
    startProcess() {
      this.$refs['synErrorDialog'].close()
      this.$emit('restart')
    },
    openDialog () {
      this.$refs['synErrorDialog'].open()
    }
  }
}
</script>


// WEBPACK FOOTER //
// SyncErrorDialog.vue?f3f106d0